
import React, { Component, } from 'react';
import {Modal, ModalHeader, ModalBody, Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import PaymentDialogueStatusView from '../payment/PaymentDialogueStatusView'
import RefundChargeLinesDialogue from './RefundChargeLinesDialogue'

var stringUtil = require('../../../../utils/string/stringUtil.js');
var formatter = require('../../../../utils/formatter/formatter.js');
var dateUtil = require('../../../../utils/dateUtil/dateUtil.js');
var saleCalculator = require('../../../../utils/domain/sales/saleCalculator');
var viewUtil = require('../../../../utils/view/viewUtil.js');
var constants = require('../../../../utils/domain/constants.js');
var printUtil = require('../../../../utils/print/printUtil.js');
var stateManager = require('../../../../utils/state/stateManager.js');
var commonUtility = require('../../../../utils/domain/commonUtility.js');
var staffUtility = require('../../../../utils/domain/staff/staffUtility');
var saleInitializer = require('../../../../utils/domain/sales/saleInitializer');
var rmsApiProxyRetry = require('../../../../utils/api/rmsApiProxyRetry');
var creditCardProcessor = require('../../../../utils/creditCardProcessor/creditCardProcessor.js');
var arraySort = require('array-sort');
var localizationUtils = require('../../../../utils/domain/localizationUtils');
const translator = require('../../../../utils/translator/translator.js');


class RefundDialogue extends Component
{

    constructor(props)
    {
        super(props);

        this.renderOutputScreenPanel = this.renderOutputScreenPanel.bind(this);
        this.renderTransactionHistoryPanel = this.renderTransactionHistoryPanel.bind(this);
        this.renderKeyPadPanel = this.renderKeyPadPanel.bind(this);
        this.renderOtherPaymentTypesPanel = this.renderOtherPaymentTypesPanel.bind(this);

        this.onNumberEntered = this.onNumberEntered.bind(this);
        this.onPaymentMethodClick = this.onPaymentMethodClick.bind(this);
        this.onCashPayment = this.onCashPayment.bind(this);
        this.onCreditCardPayment = this.onCreditCardPayment.bind(this);
        this.onOfflineCreditCardRefund = this.onOfflineCreditCardRefund.bind(this);
        this.onPercentageKeyEntered = this.onPercentageKeyEntered.bind(this);
        this.onFullAmountClick = this.onFullAmountClick.bind(this);



        this.state ={};
        this.state.refundableAmount = saleCalculator.calculateTotalRefundableAmount(this.props.sale);
        this.state.displayAmount =  0.0;
        this.state.refundedAmount = saleCalculator.calculateTotalRefunds(this.props.sale);
        if (props.partialRefundableAmount != null && props.partialRefundableAmount > constants.numericThresholdValue &&
            props.partialRefundableAmount < saleCalculator.calculateTotalRefundableAmount(this.props.sale))
        {
            this.state.displayAmount =  props.partialRefundableAmount;
            this.state.refundableAmount = props.partialRefundableAmount;
            this.state.refundedAmount = 0;
        }
        

        this.state.screenAmountNeedsToBeCleared = true;
        
        this.state.keyPadDisabled = false;
        this.state.paymentDisabled = this.state.keyPadDisabled;
        this.state.cashPaymentDisabled = this.state.paymentDisabled;
        this.state.creditCardDisabled = this.state.paymentDisabled;
        this.state.otherPaymentsDisabled = this.state.paymentDisabled;
        
        this.state.paymentModified = false;

        this.resetPaymentServerStatusViewState();
    }

    render()
    {
        this.state.keyPadDisabled = this.state.refundableAmount <= constants.numericThresholdValue;
        this.state.paymentDisabled = this.state.keyPadDisabled || this.state.displayAmount <= constants.numericThresholdValue;

        this.state.cashPaymentDisabled = this.state.paymentDisabled;
        this.state.creditCardDisabled = this.state.paymentDisabled;
        this.state.otherPaymentsDisabled = this.state.paymentDisabled;
       
       return(<div>
                <Modal isOpen={true} centered animation={false} fade={false} size="lg" style={{maxWidth: '1600px', width: '90%'}}>
                        <ModalBody style={{margin:'-10px'}}>
                                
                                <div style={{height:'80vh'}}>
                                    
                                    <table height="100%" width="100%">
                                        <tr height="10%">
                                            {this.renderOutputScreenPanel()}
                                        </tr>
                                        
                                        <tr height="0%">
                                            <td>
                                                <hr style={{margin:'0px'}}/>
                                            </td>
                                        </tr>
                                        
                                        <tr>
                                            <table width="100%" height="100%">
                                                <tr>
                                                    <td width="50%" height="100%">
                                                        {this.renderTransactionHistoryPanel()}
                                                    </td>
                                                    <td height="100%">
                                                        {this.renderKeyPadPanel()}
                                                    </td>
                                                </tr>
                                            </table>
                                        </tr>
                                    </table>    
        
                                </div>
                                
                        </ModalBody>
                    </Modal>
                    {this.renderPaymentServerStatusView()}
                    {this.renderRefundChargeLinesDialogue()}
                </div>);
    }

    renderOutputScreenPanel()
    {
        return (
                    <div style={{background:"white", color:"#484848", height:"100%", width:"100%", padding:'5px'}}>
                        <table width="100%" height="100%">
                            <tr>
                                <td width="40%" valign="top">
                                    <div style={{fontSize:'12px', marginTop:'10px'}}>
                                            <table>
                                                <tr>
                                                    <td>{translator.getLabel("total_sale")}</td>
                                                    <td><div style={{marginLeft:'5px'}} >{formatter.convertToCurrencyFormat(saleCalculator.calculateTotalNetSalePrice(this.props.sale))}</div> </td>
                                                </tr>
                                                <tr>
                                                    <td>{translator.getLabel("paid")}</td>
                                                    <td><div style={{marginLeft:'5px'}} >{formatter.convertToCurrencyFormat(this.props.sale.paidAmount)}</div> </td>
                                                </tr>
                                                <tr>
                                                    <td>{translator.getLabel("refunds")}</td>
                                                    <td><div style={{marginLeft:'5px'}} >{formatter.convertToCurrencyFormat(this.state.refundedAmount)}</div> </td>
                                                </tr>
                                            </table>
                                        </div>
                                </td>
                                <td width="60%">
                                    <div align="right" verticalAlign="middle" style={{color:"#484848", fontSize:'6vh'}}>
                                        {formatter.convertToCurrencyFormat(this.state.displayAmount)}
                                    </div>
                                </td>
                            </tr>
                        </table>    
                    </div>

                )
    }

    renderTransactionHistoryPanel = ()=>
    {

        var receiptLines = arraySort(this.props.sale.receiptLines, "dateTime")

        var components = [];
        receiptLines.forEach(receiptLine =>
        {
            components.push(<tr>
                                <table width="100%">
                                    <tr>
                                        <td>
                                            <span><strong>{receiptLine.type}  /  {formatter.convertToCurrencyFormat(receiptLine.amount)} / {dateUtil.convertToLocalStandard(receiptLine.dateTime)}</strong></span>
                                        </td>
                                    </tr>
                                    <tr>
                                    <td style={{wordBreak:'break-all'}}>
                                            {receiptLine.line}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <hr style={{margin:'0px', padding:'0px', marginBottom:'5px'}}/>
                                        </td>
                                    </tr>
                                </table>
                            </tr>)
        });


        return (<div style={{height:'99%', width:'100%', padding:'5px', marginTop:'2px', background:'#D3D3D3', fontSize:'12px', overflowY:'auto', borderRadius: '10px'}}>
                    <table width="100%">
                        {components}
                    </table>
                </div>)
    }

    renderKeyPadPanel = () =>
    {
        var currencyDenominations = localizationUtils.getCurrencyDenominations();
        return (
            <table width="100%" height="100%" style={{ borderCollapse: 'separate', borderSpacing: '4px' }}>
                <tr>
                    <td width="25%">
                        {this.renderOtherPaymentTypesPanel()}
                    </td>
                    <td width="25%">
                        <Button color="primary" disabled={this.state.cashPaymentDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={this.onCashPayment}>{translator.getLabel("cash")}</Button>
                    </td>
                    <td width="25%">
                        <Button color="success" disabled={this.state.creditCardDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={this.onCreditCardPayment}>{translator.getLabel("credit")}</Button>
                    </td>
                    <td width="25%">
                        <Button color="danger" style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.props.onClose(this.state.paymentModified) }}>{translator.getLabel("close")}</Button>
                    </td>
                </tr>
                <tr>
                    <td width="25%">
                        <Button color="success" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem', whiteSpace: 'nowrap' }} onClick={() => { this.onFullAmountClick() }}>{translator.getLabel("full_amount")}</Button>
                    </td>
                    <td width="25%">
                        <Button disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontWeight: 'bold', fontSize: '1.3rem', background: '#1226bd' }} onClick={() => { this.onPercentageKeyEntered(0.75) }}>75%</Button>
                    </td>
                    <td width="25%">
                        <Button disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontWeight: 'bold', fontSize: '1.3rem', background: '#253bea' }} onClick={() => { this.onPercentageKeyEntered(0.50) }}>50%</Button>
                    </td>
                    <td width="25%">
                        <Button disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontWeight: 'bold', fontSize: '1.3rem', background: '#5f6ff0' }} onClick={() => { this.onPercentageKeyEntered(0.25) }}>25%</Button>
                    </td>
                </tr>

                <tr>
                    <td >
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(7) }} className='payment-number-button-style'>7</Button>
                    </td>
                    <td >
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(8) }} className='payment-number-button-style'>8</Button>
                    </td>
                    <td >
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(9) }} className='payment-number-button-style'>9</Button>
                    </td>
                    <td >
                        <Button disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontWeight: 'bold', fontSize: '1.3rem', background: '#33658A' }} onClick={() => { this.onNumberEntered(currencyDenominations[0] * 100) }}>{formatter.convertToCurrencyFormat(currencyDenominations[0])}</Button>
                    </td>
                </tr>

                <tr>
                    <td >
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(4) }} className='payment-number-button-style'>4</Button>
                    </td>
                    <td >
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(5) }} className='payment-number-button-style'>5</Button>
                    </td>
                    <td >
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(6) }} className='payment-number-button-style'>6</Button>
                    </td>
                    <td >
                        <Button disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontWeight: 'bold', fontSize: '1.3rem', background: '#86BBD8' }} onClick={() => { this.onNumberEntered(currencyDenominations[1] * 100) }}>{formatter.convertToCurrencyFormat(currencyDenominations[1])}</Button>
                    </td>
                </tr>

                <tr>
                    <td >
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(1) }} className='payment-number-button-style'>1</Button>
                    </td>
                    <td>
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(2) }} className='payment-number-button-style'>2</Button>
                    </td>
                    <td>
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(3) }} className='payment-number-button-style'>3</Button>
                    </td>
                    <td>
                        <Button disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontWeight: 'bold', fontSize: '1.3rem', background: '#F6AE2D' }} onClick={() => { this.onNumberEntered(currencyDenominations[2] * 100) }}>{formatter.convertToCurrencyFormat(currencyDenominations[2])}</Button>
                    </td>
                </tr>

                <tr>
                    <td>
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontWeight: 'bold', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(-1) }} className='payment-number-button-style'>◄</Button>
                    </td>
                    <td>
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(0) }} className='payment-number-button-style'>0</Button>
                    </td>
                    <td>
                        <Button color="secondary" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontSize: '1.3rem' }} onClick={() => { this.onNumberEntered(-2) }} className='payment-number-button-style'>00</Button>
                    </td>
                    <td>
                        <Button color="danger" disabled={this.state.keyPadDisabled} style={{ width: '100%', height: '100%', fontWeight: 'bold', fontSize: '1.3rem', background: '#F26419' }} onClick={() => { this.onNumberEntered(currencyDenominations[3] * 100) }}>{formatter.convertToCurrencyFormat(currencyDenominations[3])}</Button>
                    </td>
                </tr>

            </table>

        )
    }

    renderOtherPaymentTypesPanel()
    {
        var paymentTypes = stateManager.getStore().getState().paymentTypes;
        if (paymentTypes == null)
            paymentTypes = [];

        paymentTypes = paymentTypes.filter(p => stringUtil.isStringNullOrEmpty(p.expiryDate) || dateUtil.isSameOrAfter(p.expiryDate, dateUtil.getToday()));
        paymentTypes.push(this.createCreditBookPaymentType());

        if (paymentTypes.length <= 0)
        {
            return (<ButtonDropdown disabled={true} color="warning" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} isOpen={this.state.dropdownOpen} toggle={()=>{
                                                                                                                                                                            this.state.dropdownOpen = !this.state.dropdownOpen;
                                                                                                                                                                            this.setState({})
                                                                                                                                                                        }}>
                        <DropdownToggle disabled={true} color="warning" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} caret>
                        {translator.getLabel("others")}
                        </DropdownToggle>

                    </ButtonDropdown>);
        }

        var buttonComponents = [];

        paymentTypes.forEach(paymentType =>
        {
            var isDisabled = this.state.otherPaymentsDisabled || this.props.sale.venueCode != constants.VenueCodeProperty;

            let color = "dark";
            if (paymentType.type == constants.PaymentMethodCreditBook)
                color = "primary"


            buttonComponents.push(<DropdownItem>
                                        <Button color={color} disabled={isDisabled} style={{minWidth:'300px', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onPaymentMethodClick(paymentType)}}>{paymentType.code}</Button>
                                    </DropdownItem>) 
        });

        return(<ButtonDropdown disabled={this.state.keyPadDisabled} color="warning" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} isOpen={this.state.dropdownOpen} toggle={()=>{
                                                                                                                                                        this.state.dropdownOpen = !this.state.dropdownOpen;
                                                                                                                                                        this.setState({})
                                                                                                                                                    }}>
                <DropdownToggle disabled={this.state.keyPadDisabled} color="warning" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} caret>
                {translator.getLabel("others")}
                </DropdownToggle>
                <DropdownMenu>
                    {buttonComponents}
                </DropdownMenu>
                </ButtonDropdown>)
    }

    createCreditBookPaymentType()
    {
        var creditBookPaymentType = {};
        creditBookPaymentType.id = constants.PaymentMethodCreditBook;
        creditBookPaymentType.franchisorId = commonUtility.getFranchisor().id;
        creditBookPaymentType.code = constants.PaymentMethodCreditBook;
        creditBookPaymentType.name = constants.PaymentMethodCreditBook;
        creditBookPaymentType.description = constants.PaymentMethodCreditBook;
        creditBookPaymentType.type = constants.PaymentMethodCreditBook;
        creditBookPaymentType.maxAmount = Number.MAX_SAFE_INTEGER;
        creditBookPaymentType.expiryDate = null;
        creditBookPaymentType.openCashDrawer = false;
        creditBookPaymentType.notes = "";

        return creditBookPaymentType;
    }

    onNumberEntered = (number) =>
    {
        var currencyDenominations = localizationUtils.getCurrencyDenominations();   

        if (this.state.screenAmountNeedsToBeCleared)
        {
            this.state.screenAmountNeedsToBeCleared = false;
            this.state.displayAmount = 0;
        }

        if ( (number == currencyDenominations[0] * 100) || (number == currencyDenominations[1] * 100) || 
             (number == currencyDenominations[2] * 100) || (number == currencyDenominations[3] * 100))
        {
            this.state.displayAmount = 0;
            this.state.screenAmountNeedsToBeCleared = true;
        }

        if (number >= 0)
        {
            this.state.displayAmount = formatter.roundUp(this.state.displayAmount * 10 + number / 100, 2);
        }

        if (number == -1)
        {
            this.state.displayAmount = formatter.roundUp(Math.round(100 * this.state.displayAmount/10) / 100, 2);
        }

        if (number == -2)
        {
            this.state.displayAmount = formatter.roundUp(this.state.displayAmount * 100, 2);
        }


        this.setState({});
    }

    onFullAmountClick()
    {
        this.state.displayAmount = this.state.refundableAmount;
        this.state.screenAmountNeedsToBeCleared = true;
        this.setState({});
    }

    onPercentageKeyEntered(percentage)
    {
        var currentRemainingAmount = this.state.refundableAmount;
        var percentageAmount = formatter.roundUp(currentRemainingAmount * percentage, 2);
        var remainingAmountAfterPercentage = formatter.roundUp(currentRemainingAmount - percentageAmount, 2);

        if (percentageAmount < 0.25 || remainingAmountAfterPercentage < 0.25)
            return;

        this.state.displayAmount = percentageAmount;
        this.state.screenAmountNeedsToBeCleared = true;
        this.setState({});
    }

    onPaymentMethodClick(paymentType)
    {

        if (this.state.displayAmount > this.state.refundableAmount)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("refund_cannot_exceed")} ${formatter.convertToCurrencyFormat(this.state.refundableAmount)}`);
            this.state.screenAmountNeedsToBeCleared = true;
            return;
        }

        if (this.state.displayAmount > saleCalculator.calculateRefundableForPaymentType(this.props.sale, paymentType.code))
        {
            viewUtil.showErrorAlert(`${translator.getLabel("refund_cannot_exceed")} ${formatter.convertToCurrencyFormat(saleCalculator.calculateRefundableForPaymentType(this.props.sale, paymentType.code))}`);
            this.state.screenAmountNeedsToBeCleared = true;
            return;
        }

        if (paymentType.type == constants.PaymentMethodCreditBook)
        {
            this.onCreditBookPayment();
            return;
        }

        var refund = {};
        refund.refundCode = this.props.refundCode;
        refund.refundReason = this.props.refundCode;
        refund.refundAmount = this.state.displayAmount;
        refund.operator = staffUtility.getStaffCompleteName(this.props.refundStaff);
        this.state.refundableAmount = this.state.refundableAmount - this.state.displayAmount;
        this.state.refundedAmount = this.state.refundedAmount + this.state.displayAmount;
        this.props.sale.refunds.push(refund);

        var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeRefund, this.state.displayAmount, paymentType.code);
        this.props.sale.receiptLines.push(receiptLine);


        printUtil.openCashDrawer();

        this.state.displayAmount = 0.0;
        this.state.paymentModified = true;
        this.state.screenAmountNeedsToBeCleared = true;
        
        this.setState({});
    }

    async onCreditBookPayment()
    {
        try
        {
            let creditBookId = null;
            let creditAccountId = null;
            let creditBookDetails = null;
            this.props.sale.receiptLines.forEach (r =>
            {
                var line = JSON.parse(r.line);
                if (r.type == constants.ReceiptLineTypeCharge && line.mode == constants.PaymentMethodCreditBook)
                {
                    creditBookId = line.creditBookId;
                    creditAccountId = line.creditAccountId;
                    creditBookDetails = line.creditBookDetails;
                }
            });

            if (creditBookId == null || creditAccountId == null)
            {
                viewUtil.showErrorAlert(translator.getLabel("failed_to_find_credit_account_details_from_receipt_lines"));
                return;
            }

            this.state.paymentServerStatusMessage = "Please Wait";
            this.state.paymentServerDisplayType = 'status';
            this.setState({});

            let transaction = {};
            transaction.reference = this.props.sale.number;
            transaction.amount = this.state.displayAmount;
            transaction.dateTime = dateUtil.getNow();
            transaction.type = 'Debit';
            
            let resource = `${rmsApiProxyRetry.getOrgContextToUrl()}/accounts/creditBooks/${creditBookId}/${creditAccountId}`;
            var result = await rmsApiProxyRetry.post(resource, transaction); 

            if (result.status == "approved")
            {
                var refund = {};
                refund.refundCode = this.props.refundCode;
                refund.refundReason = this.props.refundCode;
                refund.refundAmount = this.state.displayAmount;
                refund.operator = staffUtility.getStaffCompleteName(this.props.refundStaff);
                this.state.refundableAmount = this.state.refundableAmount - this.state.displayAmount;
                this.state.refundedAmount = this.state.refundedAmount + this.state.displayAmount;
                this.props.sale.refunds.push(refund);

                var line = {};
                line.creditBookId = creditBookId;
                line.creditAccountId = creditAccountId;
                line.creditBookDetails = creditBookDetails;
                line.mode = constants.PaymentMethodCreditBook;
                line.reference = result.reference;
                var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeRefund, this.state.displayAmount, constants.PaymentMethodCreditBook);
                receiptLine.line = JSON.stringify(line);
                this.props.sale.receiptLines.push(receiptLine);

                this.state.displayAmount = 0.0;
                this.state.paymentModified = true;
                this.state.screenAmountNeedsToBeCleared = true;
                this.state.paymentServerDisplayType = 'success';
                this.setState({});

            }
            else
            {
                this.state.paymentServerDisplayType = 'decline';
                this.setState({});
            }

        }
        catch(error)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("error_occurred_while_performing_refund_in_credit_book")}: ${error}`);
        }
        

    
    }

    onCashPayment = () =>
    {

        if (this.state.displayAmount > this.state.refundableAmount)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("refund_cannot_exceed")} ${formatter.convertToCurrencyFormat(this.state.refundableAmount)}`);
            this.state.screenAmountNeedsToBeCleared = true;
            return;
        }

        if (this.state.displayAmount > saleCalculator.calculateTotalCashRefundable(this.props.sale))
        {
            viewUtil.showErrorAlert(`${translator.getLabel("cash_refund_cannot_exceed")} ${formatter.convertToCurrencyFormat(saleCalculator.calculateTotalCashRefundable(this.props.sale))}`);
            this.state.screenAmountNeedsToBeCleared = true;
            return;
        }

        var refund = {};
        refund.refundCode = this.props.refundCode;
        refund.refundReason = this.props.refundCode;
        refund.refundAmount = this.state.displayAmount;
        refund.operator = staffUtility.getStaffCompleteName(this.props.refundStaff);
        this.state.refundableAmount = this.state.refundableAmount - this.state.displayAmount;
        this.state.refundedAmount = this.state.refundedAmount + this.state.displayAmount;
        this.props.sale.refunds.push(refund);

        var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeRefund, this.state.displayAmount, constants.PaymentMethodCash);
        this.props.sale.receiptLines.push(receiptLine);


        printUtil.openCashDrawer();

        this.state.displayAmount = 0.0;
        this.state.paymentModified = true;
        this.state.screenAmountNeedsToBeCleared = true;
        
        this.setState({});
    }

    onCreditCardPayment = () =>
    {
        if (this.props.sale.paymentMethod == constants.PaymentMethodVenuePaid)
        {
            this.onVenuePaidPayment();
            return;
        }

        if (this.state.displayAmount > this.state.refundableAmount)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("refund_cannot_exceed")} ${formatter.convertToCurrencyFormat(this.state.refundableAmount)}`);
            this.state.screenAmountNeedsToBeCleared = true;
            return;
        }

        if (this.state.displayAmount > saleCalculator.calculateTotalCreditCardRefundable(this.props.sale))
        {
            viewUtil.showErrorAlert(`${translator.getLabel("card_refund_cannot_exceed")} ${formatter.convertToCurrencyFormat(saleCalculator.calculateTotalCreditCardRefundable(this.props.sale))}`);
            this.state.screenAmountNeedsToBeCleared = true;
            return;
        }

        var creditCardTerminal = stateManager.getStore().getState().creditCardTerminal;

        if (creditCardTerminal == null || stringUtil.isStringNullOrEmpty(creditCardTerminal.provider))
        {
            viewUtil.showErrorAlert(translator.getLabel("credit_card_provider_settings_are_not_configured_for_this_terminal"))
            return;
        }

        if (stringUtil.areStringSame(creditCardTerminal.provider, "Offline"))
        {
            this.onOfflineCreditCardRefund();
            return;
        }

        var cardDriver = creditCardTerminal.underlyingDriver;

        if (cardDriver.extractRefundableLines == null)
        {
            this.executeCreditCardRefunds(cardDriver);
            return;
        }

        var refundableChargeLines = cardDriver.extractRefundableLines(this.props.sale.receiptLines)
        if (refundableChargeLines == null || refundableChargeLines.length <= 0)
        {
            viewUtil.showErrorAlert(translator.getLabel("no_corresponding_payment_found_for_refunds"))
            return;
        }

        if (refundableChargeLines.length == 1)
        {
            this.executeCreditCardRefunds(cardDriver, refundableChargeLines[0].chargeId);
            return;
        }

       this.state.refundableChargeLines = refundableChargeLines;
       this.state.cardDriver = cardDriver;
       this.setState({});
        
    }

    executeCreditCardRefunds = (cardDriver, chargeId)=>
    {
        this.state.paymentServerStatusMessage = "Please Wait";
        this.state.paymentServerDisplayType = 'status';
        cardDriver.refundAmount(this.state.displayAmount, 
        (notificationMessage) =>
        {
            //On Status Message
            this.state.paymentServerDisplayType = 'status';
            this.state.paymentServerStatusMessage = notificationMessage;
            this.setState({});
        }, 
        (errorMessage) =>
        {
            //On Error Message
            this.state.paymentServerDisplayType = 'error';
            this.state.paymentServerErrorMessage = errorMessage;
            this.setState({});
        }, 
        (requestId, receiptLines)=>
        {
            //On Signature Verification
            printUtil.printCardSignatureVerification(receiptLines);
            this.state.paymentServerVerificationRequestId = requestId;
            this.state.paymentServerDisplayType = 'signature_verification';
            this.setState({});
        },
        ()=>
        {
            //On Signature Verification Timeout
            this.state.paymentServerDisplayType = 'status';
            this.setState({});
        },
        (result) =>
        {
            //On Success

            var refund = {};
            refund.refundCode = this.props.refundCode;
            refund.refundReason = this.props.refundCode;
            refund.refundAmount = this.state.displayAmount;
            refund.operator = staffUtility.getStaffCompleteName(this.props.refundStaff);
            this.state.refundableAmount = this.state.refundableAmount - this.state.displayAmount;
            this.state.refundedAmount = this.state.refundedAmount + this.state.displayAmount;
            this.props.sale.refunds.push(refund);

            var line = {};
            line.transactionType = result.transactionType;
            line.driver = result.driver;
            line.cardSchemeName = result.cardSchemeName;
            line.dateOfExpiry = result.dateOfExpiry;
            line.primaryAccountNumber = result.primaryAccountNumber;
            line.cardholderVerificationMethod = result.cardholderVerificationMethod;
            line.paymentMethod = result.paymentMethod;
            line.tpi = result.tpi;
            line.transactionTime = result.transactionTime;
            line.amountTotal = result.amountTotal;
            line.transactionResult = result.transactionResult;
            line.transactionId = result.transactionId;
            line.authCode = result.authCode;
            line.mode = constants.PaymentMethodCredit;
            line.chargeId = result.chargeId;
            var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeRefund, this.state.displayAmount, constants.PaymentMethodCredit);
            receiptLine.line = JSON.stringify(line);
            this.props.sale.receiptLines.push(receiptLine);

            this.state.displayAmount = 0.0;
            this.state.paymentModified = true;
            this.state.screenAmountNeedsToBeCleared = true;
            this.state.paymentServerDisplayType = 'success';
            this.setState({});
        },
        () =>
        {
            this.state.paymentServerDisplayType = 'decline';
            this.setState({});
        }, chargeId);

        this.setState({});
    }

    onOfflineCreditCardRefund = ()=>
    {
        var refund = {};
        refund.refundCode = this.props.refundCode;
        refund.refundReason = this.props.refundCode;
        refund.refundAmount = this.state.displayAmount;
        refund.operator = staffUtility.getStaffCompleteName(this.props.refundStaff);
        this.state.refundableAmount = this.state.refundableAmount - this.state.displayAmount;
        this.state.refundedAmount = this.state.refundedAmount + this.state.displayAmount;
        this.props.sale.refunds.push(refund);

        var line = {};
        line.transactionType = "Offline Credit Refund"
        line.mode = constants.PaymentMethodCredit;
        var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeRefund, this.state.displayAmount, constants.PaymentMethodCredit);
        receiptLine.line = JSON.stringify(line);
        this.props.sale.receiptLines.push(receiptLine);

        
        this.state.displayAmount = 0.0;
        this.state.paymentModified = true;
        this.state.screenAmountNeedsToBeCleared = true;
        this.setState({});
        return;
    }

    onVenuePaidPayment = () =>
    {

        if (!creditCardProcessor.canHandleRefund(this.props.sale))
        {
            viewUtil.showErrorAlert(`${translator.getLabel("no_card_processor_found_that_can_handle_payments_of_venue")} '${this.props.sale.venueCode}'`);
            return;
        }

        if (this.state.displayAmount > this.state.refundableAmount)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("refund_cannot_exceed")} ${formatter.convertToCurrencyFormat(this.state.refundableAmount)}`);
            this.state.screenAmountNeedsToBeCleared = true;
            return;
        }

        if (this.state.displayAmount > this.state.refundableAmount)
        {
            viewUtil.showErrorAlert(`${translator.getLabel("refund_cannot_exceed")} ${formatter.convertToCurrencyFormat(this.state.refundableAmount)}`);
            this.state.screenAmountNeedsToBeCleared = true;
            return;
        }

        this.state.paymentServerStatusMessage = "Please Wait";
        this.state.paymentServerDisplayType = 'status';
            
        creditCardProcessor.performRefund(this.props.sale, this.state.displayAmount)
        .then(
                (result) =>
                {
                    var refund = {};
                    refund.refundCode = this.props.refundCode;
                    refund.refundReason = this.props.refundCode;
                    refund.refundAmount = this.state.displayAmount;
                    refund.operator = staffUtility.getStaffCompleteName(this.props.refundStaff);
                    this.state.refundableAmount = this.state.refundableAmount - this.state.displayAmount;
                    this.state.refundedAmount = this.state.refundedAmount + this.state.displayAmount;
                    this.props.sale.refunds.push(refund);

                    var receiptLine = saleInitializer.createReceiptLine(constants.ReceiptLineTypeRefund, this.state.displayAmount, constants.PaymentMethodVenuePaid);

                    var line = JSON.parse(receiptLine.line);
                    line.rawResult = JSON.stringify(result);
                    receiptLine.line = JSON.stringify(line);
                    this.props.sale.receiptLines.push(receiptLine);

                    this.state.displayAmount = 0.0;
                    this.state.paymentModified = true;
                    this.state.screenAmountNeedsToBeCleared = true;
                    this.state.paymentServerDisplayType = 'success';

                    this.setState({});
                }, 
                (errorMessage) =>
                {
                    this.state.paymentServerDisplayType = 'error';
                    this.state.paymentServerErrorMessage = errorMessage;
                    this.setState({});
                }
            );
        this.setState({});
    }

    renderPaymentServerStatusView  = () =>
    {
        if (this.state.paymentServerDisplayType == null)
            return null;

        return <PaymentDialogueStatusView displayType={this.state.paymentServerDisplayType} 
                                        statusMessage={this.state.paymentServerStatusMessage}
                                        errorMessage={this.state.paymentServerErrorMessage}
                                        onErrorClose={this.onPaymentServerStatusViewErrorClose}
                                        onSuccessClose={this.onPaymentServerStatusViewSuccessClose}
                                        onDeclineClose={this.onPaymentServerStatusViewDeclineClose}
                                        onCardVerified={this.onCardVerified}
                                        onCardNotVerified={this.onCardNotVerified}></PaymentDialogueStatusView>
    }

    renderRefundChargeLinesDialogue = () =>
    {
        if (this.state.refundableChargeLines == null)
            return null;

        return <RefundChargeLinesDialogue refundableChargeLines={this.state.refundableChargeLines}
                                            onOk = {(selectedRefundChargeLine)=>
                                            {
                                                let cardDriver = this.state.cardDriver;

                                                this.state.refundableChargeLines = null;
                                                this.state.cardDriver = null;
                                                this.setState({});

                                                if (selectedRefundChargeLine.refundable < this.state.displayAmount)
                                                {
                                                    viewUtil.showErrorAlert(`${translator.getLabel("refund_amount_cannot_exceed")} ${formatter.convertToCurrencyFormat(selectedRefundChargeLine.refundable)} ${translator.getLabel("for_the_selected_payment_line")}`);
                                                    return;
                                                }

                                                this.executeCreditCardRefunds(cardDriver, selectedRefundChargeLine.chargeId)
                                            }}
                                            onCancel = {()=>
                                            {
                                                this.state.refundableChargeLines = null;
                                                this.state.cardDriver = null;
                                                this.setState({});
                                            }}
                                            ></RefundChargeLinesDialogue>
    }

    onPaymentServerStatusViewErrorClose = ()=>
    {
        this.resetPaymentServerStatusViewState();
        this.setState({});
    }

    onPaymentServerStatusViewSuccessClose = ()=>
    {
        this.resetPaymentServerStatusViewState();
        this.setState({});
    }

    onPaymentServerStatusViewDeclineClose = ()=>
    {
        this.resetPaymentServerStatusViewState();
        this.setState({});
    }

    onCardVerified = () =>
    {
        var creditCardTerminal = stateManager.getStore().getState().creditCardTerminal;
        var cardDriver = creditCardTerminal.underlyingDriver;
        cardDriver.verifyCardSignature(this.state.paymentServerVerificationRequestId, true);

        this.state.signatureVerified = true;
        this.state.paymentServerDisplayType = 'status';
        this.setState({});
    }

    onCardNotVerified = () =>
    {
        var creditCardTerminal = stateManager.getStore().getState().creditCardTerminal;
        var cardDriver = creditCardTerminal.underlyingDriver;
        cardDriver.verifyCardSignature(this.state.paymentServerVerificationRequestId, false);

        this.state.paymentServerDisplayType = 'status';
        this.setState({});
    }

    resetPaymentServerStatusViewState = ()=>
    {
        this.state.paymentServerDisplayType = null;
        this.state.paymentServerStatusMessage = "";
        this.state.paymentServerErrorMessage = "";
        this.state.paymentServerVerificationRequestId = null;
    }




}


export default RefundDialogue;